import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const removeAsPartnerUser = async (codeName: string, email: string): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation RemoveAsPartnerUser($codeName: String!, $email: String!) {
        removeAsPartnerUser(codeName: $codeName, email: $email)
      }
    `),
    variables: {
      codeName,
      email,
    },
  });

  return !!response.data?.removeAsPartnerUser;
};
